"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

Vue.component("heading", require("./Heading.vue").default);

exports.default = {
  props: ["type", "test", "url", "project", "errors", "old"]
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/printtest/PrintTest.vue
// module id = Z05Z
// module chunks = 0 1